<script setup lang='ts'>
const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const appConfig = useRuntimeConfig().public;

const mostCommonSportTypesList = appConfig.APP_CUSTOMER.most_common_sport_types_list as TSportType[];

const searchValue = ref(route.query.q as string);

const clearSearch = () => (searchValue.value = "");
const onSearch = () =>
  router.push({ path: "/search/", query: { q: searchValue.value } });
</script>

<template>
  <BaseSearchInput
    v-model="searchValue"
    :most-common-sport-types-list="mostCommonSportTypesList"
    :placeholder="t('labels.search')"
    class="hidden lg:block w-[15rem]"
    root-class="truncate"
    @keyup.enter="onSearch()"
    @clear="clearSearch()"
  />
  <BaseButton
    class="flex items-center justify-center lg:hidden" type="icon" name="search" title="Search"
    @click="onSearch()"
  >
    <IconSearch class="mx-2 text-secondary" />
  </BaseButton>
</template>
